/**
 * 月度对账 表单验证规则
 * @author zjs
 * @time 2023-04-23
 */
export default {
    data () {
        return {
            formRules: {
                'month_plan' : [{ required: true, trigger: 'blur' }],
                'yingshou_plan' : [{ required: true, trigger: 'blur' }]
            }
        }
    },
    methods: {
        validateProduct (arr) {
            let msg = ''
            let index = -1 
            for (let i in arr) {
                let row = arr[i]
                if (!row.weidu_id) {
                    msg += '"品牌纬度"'
                }
                if (!row.yewuxian) {
                    msg += '"业务线标识"'
                }
                if (!row.weidu_id) {
                    msg += '"品牌纬度"'
                }
                if (!row.caigou_plan) {
                    msg += '"采购计划数"'
                }
                if (!row.xiaoshou_plan) {
                    msg += '"销售计划数"'
                }
                if (!row.storage_plan) {
                    msg += '"计划库存数"'
                }
                if (msg.length > 0) {
                    index = i
                    break;
                }
            }
            if (index >= 0) {
                msg = '第' + parseInt(parseInt(index) + 1) + '行还未选择\n' + msg
            }
            return msg
        }
    }
}